<template>
  <base-page
    max-width="md:ps-max-w-md"
    class="ps-me ps-absolute ps-bottom-0 ps-left-0 mx-auto"
    @dismiss="dismiss"
  >
    <div class="flex-1 flex flex-col p-8">
      <user-avatar
        :user="currentUser"
        class="w-32 h-32 flex-shrink-0 mx-auto bg-black rounded-full"
      />
      <h3 class="mt-6 text-gray-900 text-sm leading-5 font-medium text-center">
        {{ currentUser.provided_name }}
      </h3>
      <dl class="mt-1 flex-grow flex flex-col justify-between text-center">
        <dt class="sr-only">Account</dt>
        <dd class="text-gray-500 text-sm leading-5">{{ accountName }}</dd>
        <dt class="sr-only">Role</dt>
        <dd class="mt-3">
          <span
            class="px-2 py-1 text-teal-800 text-xs leading-4 font-medium bg-teal-100 rounded-full"
            >{{ currentUser.role.name }}</span
          >
        </dd>
      </dl>
    </div>
    <div class="border-t border-b border-gray-200">
      <div class="-mt-px flex">
        <div class="w-0 flex-1 flex border-r border-gray-200">
          <a
            :href="dashboardUrl"
            class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-150"
          >
            <svg
              class="w-5 h-5 text-gray-400"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              ></path>
            </svg>
            <span class="ml-3">Dashboard</span>
          </a>
        </div>
        <div class="-ml-px w-0 flex-1 flex">
          <a
            href="#"
            class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-150"
            @click="handleLogout"
          >
            <svg
              class="w-5 h-5 text-gray-400"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
              ></path>
            </svg>
            <span class="ml-3">Logout</span>
          </a>
        </div>
      </div>
    </div>
  </base-page>
</template>

<script>
import { mapActions, mapState, mapMutations } from '@picnic-software/vuex'
import { ROUTE_LOGIN, ROUTE_CONTROLS } from '@/common/constants'
import BasePage from '@/components/BasePage'
import ButtonPrimary from '@/components/buttons/ButtonPrimary'
import UserAvatar from '@/components/UserAvatar'
export default {
  name: 'AppMe',
  components: {
    BasePage,
    ButtonPrimary,
    UserAvatar
  },
  computed: {
    ...mapState({
      currentUser: state => state.auth.user,
      accountName: state => state.account.name,
      token: state => state.auth.token
    }),
    dashboardUrl() {
      return `${
        process.env.VUE_APP_URL_DASHBOARD
      }/login/token?picnic_team_token=${this.token}`
    }
  },
  methods: {
    ...mapMutations({
      routerTo: 'router/to'
    }),
    ...mapActions({
      logout: 'auth/logout'
    }),
    async handleLogout() {
      await this.logout()
      this.routerTo(ROUTE_LOGIN)
    },
    dismiss() {
      this.routerTo(ROUTE_CONTROLS)
    }
  }
}
</script>
